import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import "./LargeStatCard.css";

Chart.register(ArcElement, Tooltip, Legend);

interface LargeStatCardProps {
  title: string;
  chartType: "half-doughnut" | "doughnut" | "number";
  dataset: any;
  centerText?: string;
}

export const LargeStatCard: React.FC<LargeStatCardProps> = ({
  title,
  chartType,
  dataset,
  centerText,
}) => {
  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart: any) => {
      const { width, height, ctx } = chart;
      ctx.save();

      if (chart.config.options.plugins.centerText?.enabled) {
        const text = chart.config.options.plugins.centerText.text;
        ctx.font = "40px Secular One";

        if (
          chart.config.type === "doughnut" &&
          chart.config.options.circumference === 360
        ) {
          ctx.font = "14px Secular One";
        }

        ctx.textBaseline = "middle";
        ctx.fillStyle = "#000";
        ctx.textAlign = "center";

        const xCenter = chart.getDatasetMeta(0).data[0].x;
        const yCenter = chart.getDatasetMeta(0).data[0].y;

        ctx.translate(xCenter, yCenter + 2);
        ctx.fillText(text, 0, 0);

        ctx.restore();
      }
      if (
        chart.config.type === "doughnut" &&
        chart.config.options.circumference === 180
      ) {
        ctx.font = "14px Secular One";
        ctx.fillStyle = "#333";
        ctx.font = "bold 24px Secular One";
        ctx.fillStyle = "#000";
        ctx.fillText("0", width * 0.05, height - 40);
        ctx.fillText("100", width * 0.70, height - 40);
      }

      ctx.save();
    },
  };

  Chart.register(centerTextPlugin);

  const renderChart = () => {
    if (chartType === "number") {
      return <div className="number-stat">{dataset}</div>;
    }

    if (chartType === "half-doughnut" || chartType === "doughnut") {
      const chartOptions = {
        cutout: "60%",
        rotation: chartType === "half-doughnut" ? -90 : 0,
        circumference: chartType === "half-doughnut" ? 180 : 360,
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: "right" as const,
            labels: {
              usePointStyle: true,
              boxWidth: 10,
              padding: 20,
              generateLabels: (chart: { data: any }) => {
                const { data } = chart;
                return data.labels.map((label: any, index: number) => {
                  const value = data.datasets[0].data[index];
                  return {
                    text: `  ${label}     ${value}%`,
                    fillStyle: data.datasets[0].backgroundColor[index],
                    hidden: false,
                    index,
                  };
                });
              },
            },
          },

          tooltip: {
            enabled: false,
          },
          centerText: {
            enabled: !!centerText,
            text: centerText || "",
          },
        },
      };

      return (
        <Doughnut
          data={dataset}
          options={chartOptions}
          className={`chart-style ${
            chartType === "half-doughnut"
              ? "half-doughnut-large"
              : "doughnut-large"
          }`}
        />
      );
    }

    return null;
  };

  return (
    <div className="large-stat-card chart-content-card">
      <h3 className="large-stat-card-title">{title}</h3>
      <div className="chart-content-wrapper">
        <div className="chart-container">{renderChart()}</div>
      </div>
    </div>
  );
};
